export interface PipelineVariablesEditorOptions {
  workflowId: string;
  includeGlobal: boolean;
}

export enum VariableEditorPermissionLevel {
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  UPDATE_VALUE_ONLY = 'update-value-only',
  DELETE = 'delete',
}
